import { type ConfigureStoreOptions, configureStore } from '@reduxjs/toolkit'
import { middlewares, queryReducers } from 'mmfintech-backend-api'
import thunk from 'redux-thunk'

const createStore = (options?: ConfigureStoreOptions['preloadedState']) =>
  configureStore({
    reducer: queryReducers,
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(middlewares.apiMiddleware).concat(thunk),
    ...options
  })

export const store = createStore()

// type RootState = ReturnType<typeof store.getState>

type AppStore = ReturnType<typeof createStore>
export type AppDispatch = AppStore['dispatch']
